import {IFilter} from "../../../../domain/occasions/filters/IFilter";

export class SingleValueFilter<T> implements IFilter<T>{
    private value:T;
    private isActivated;

    constructor(){
        this.isActivated = false;
    }

    public SetValue(value:T){
        this.value = value;
        this.Activate();
    }

    public IsValid(value:T): boolean {
        if(!this.isActivated || value == null){
            return true;
        }
        return  this.value === value;
    }

    public Activate(){
        this.isActivated = true;
    }

    public Deactivate(){
        this.isActivated = false;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/occasions/filters/abstract/SingleValueFilter.ts